// extracted by mini-css-extract-plugin
export default {"title":"settings_title__-1vsD"};